<template>
  <div class="info_form">
    <div class="title">
      公司相册
    </div>
    <div class="tip">相册列表</div>
    <div class="image_box">
      <div class="image_item" v-for="(item,index) in image" :key="item" @click="openView(item)">
        <img class="image" :src="item" alt="">
        <i class="el-icon-circle-close" @click="deleteImage(index)"></i>
      </div>
      <div class="image_item">
        <UploadFileWidget ref="uploadFileRef" :accept="fileTypes.join(',')" :limit-size="1024 * 1024 * 4" :beforeUpload="handleBeforeUpload" @success="handleUploadSuccess" @error="isUpload = false">
          <div class="file-top_btn" slot="target">
            <img class="img_icon" src="../../assets/img/company/upload_icon.png" alt="">
            <span> 添加公司照片 </span>
            <div class="tip">图片大小不超过4M</div>

          </div>
        </UploadFileWidget>
      </div>

    </div>
    <div class="tip_limit"><i class="el-icon-warning-outline"></i>最多上传20张，图片格式限制jpg、png、gif，大小不能超过4M，尺寸不限</div>
    <el-button class="save_button" @click="submitForm()">保存</el-button>
    <PreviewImageDialog v-model="dialogVisible" :url="currentUrl" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import UploadFileWidget from "@/utils/upload/UploadFileWidget.vue";
import PreviewImageDialog from "../../components/companyModule/PreviewImageDialog.vue";
export default {
  name: "",
  data() {
    return {
      image: [],
      fileTypes: [".jpg", ".png", ".jpeg", ".gif"],
      isUpload: false,
      dialogVisible: false,
      currentUrl: "",
    };
  },
  components: {
    UploadFileWidget,
    PreviewImageDialog,
  },
  mounted() {
    this.getCompanyDetial();
  },
  methods: {
    handleBeforeUpload(file) {
      if (this.image.length >= 20) {
        this.$message.warning("图片最多为20张");
        return false;
      }
      if (this.isUpload) {
        this.$message.warning("文件正在上传");
        return false;
      }

      this.isUpload = true;
      return true;
    },
    // 上传进度条
    handleUploadSuccess(val) {
      this.isUpload = false;
      this.image.push(val.path);
    },
    submitForm() {
      if (this.image.length == 0) {
        this.$message.warning("请上传图片");
        return false;
      }
      this.$httpcompany.axiosPost(
        this.$api.companySaveImage,
        { image: this.image },
        (res) => {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.isUpload = false;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    openView(url) {
      this.dialogVisible = true;
      this.currentUrl = url;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    deleteImage(index) {
      this.image.splice(index, 1);
    },
    getCompanyDetial() {
      this.$httpcompany.axiosGet(this.$api.companyDetail, (res) => {
        if (res.code == 200) {
          this.image = res.data.image;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.info_form {
  padding-bottom: 20px;
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #393837;
    margin-bottom: 34px;
  }
  .tip {
    font-weight: 500;
    font-size: 14px;
    color: #393837;
    margin-bottom: 10px;
  }
  .image_box {
    width: 520px;
    display: flex;
    // grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    flex-wrap: wrap;
    padding-bottom: 10px;

    .image_item {
      width: 120px;
      height: 120px;
      flex-shrink: 0;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #e6e8eb;
      cursor: pointer;
      position: relative;
      .el-icon-circle-close {
        position: absolute;
        top: -8px;
        right: -5px;
        color: #ff0000;
        cursor: pointer;
      }
      .image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
    }
    .file-top_btn {
      width: 120px;
      height: 120px;
      display: flex;
      background: #f6f6f6;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #e6e8eb;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 14px;
      color: #667085;
      cursor: pointer;
      .img_icon {
        width: 32px;
        height: 32px;
      }
      .logo_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
      .tip {
        color: #b3b3b3;
        font-size: 12px;
      }
    }
  }
  .tip_limit {
    font-weight: 400;
    font-size: 12px;
    color: #cccccc;
    margin-bottom: 40px;
    .el-icon-warning-outline {
      margin-right: 5px;
    }
  }
}

.save_button {
  width: 86px;
  height: 34px;
  background: #685ef5;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
</style>
